import { render, staticRenderFns } from "./Popper.vue?vue&type=template&id=ff480814"
import script from "./Popper.vue?vue&type=script&lang=js"
export * from "./Popper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports